module.exports = __webpack_public_path__ + "322d00ff6681cdbc5396f268d06a88ff.MP3";